import { useState } from "react";
import { useAssignFlow } from "../hooks/useInbound";
import { Button } from "@tonic/shared/components/ui";
import { Label } from "@tonic/shared/components/ui";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@tonic/shared/components/ui";
import { Card, CardContent, CardHeader, CardTitle } from "@tonic/shared/components/ui";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Recycle, Wrench, RotateCcw, Repeat } from "lucide-react";

export function AssignFlowDialog({ open, onOpenChange, item }) {
  const assignFlow = useAssignFlow(item?.id);
  const [selectedFlow, setSelectedFlow] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await assignFlow.mutateAsync({ flow: selectedFlow });
      onOpenChange(false);
    } catch (error) {
      console.error("Failed to assign flow:", error);
    }
  };

  const flows = [
    {
      id: "resale",
      name: "Resale",
      description: "Clean and list item for resale",
      icon: RotateCcw,
    },
    {
      id: "repair",
      name: "Repair",
      description: "Send item for repair or refurbishment",
      icon: Wrench,
    },
    {
      id: "rental",
      name: "Rental",
      description: "Prepare item for rental program",
      icon: Repeat,
    },
    {
      id: "recycle",
      name: "Recycle",
      description: "Process item for recycling",
      icon: Recycle,
    },
  ];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[500px]">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Assign to Flow</DialogTitle>
            <DialogDescription>
              Choose which re-commerce flow this item should follow.
            </DialogDescription>
          </DialogHeader>

          <div className="py-6">
            <Label className="text-sm text-muted-foreground mb-4 block">
              Select a flow for item {item?.reference}
            </Label>
            <RadioGroup
              value={selectedFlow}
              onValueChange={setSelectedFlow}
              className="grid grid-cols-2 gap-4"
            >
              {flows.map((flow) => {
                const Icon = flow.icon;
                return (
                  <Card
                    key={flow.id}
                    className={`relative cursor-pointer transition-colors hover:bg-muted ${
                      selectedFlow === flow.id ? "border-primary" : ""
                    }`}
                    onClick={() => setSelectedFlow(flow.id)}
                  >
                    <CardContent className="pt-4 pb-2">
                      <RadioGroupItem
                        value={flow.id}
                        id={flow.id}
                        className="absolute right-2 top-2"
                      />
                      <div className="flex flex-col items-start gap-1">
                        <Icon className="h-8 w-8 mb-2" />
                        <span className="font-medium">{flow.name}</span>
                        <span className="text-xs text-muted-foreground">
                          {flow.description}
                        </span>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </RadioGroup>
          </div>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!selectedFlow || assignFlow.isLoading}
            >
              {assignFlow.isLoading ? "Assigning..." : "Assign Flow"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
} 